
import { useRouter } from "vue-router";
import { useUser } from "../../utils/composable/useUser";
export default {
  setup() {
    const router = useRouter();
    const { logout, user, getUserInfo } = useUser();

    getUserInfo();

    const handleLogout = () => {
      logout();
      router.push({ path: "/logowanie" });
    };

    const options = [
      { icon: "add", label: "Dodaj", link: "dodaj", visibility: "admin" },
      { icon: "library", label: "Moje książki", link: "biblioteka" },
      {
        icon: "move",
        label: "Przenieś",
        link: "przenies",
        visibility: "admin",
      },
      {
        icon: "admin",
        label: "Zarządzaj",
        link: "zarzadzaj",
        visibility: "superAdmin",
      },
      { icon: "user", label: "Moje konto", link: "konto" },
      { icon: "logout", label: "Wyloguj", onClick: handleLogout },
    ];

    return { options, user };
  },
};
